export function crmActiveInput() {
  const ACTIVE_CLASS = 'farlo-ui-crm__text--active';

  // helper to add/remove active class to a given container
  function toggleActive(container, isActive) {
    if (!container) return;
    container.classList[isActive ? 'add' : 'remove'](ACTIVE_CLASS);
  }

  // generic binder for an input + its container resolver
  function bindInput(input, getContainer) {
    // on focus → always add
    input.addEventListener('focus', () => {
      const container = getContainer(input);
      toggleActive(container, true);
    });

    // on blur → remove only if empty
    input.addEventListener('blur', () => {
      const container = getContainer(input);
      toggleActive(container, input.value !== '');
    });

    // on init → if non‐empty, add
    if (input.value !== '') {
      const container = getContainer(input);
      toggleActive(container, true);
    }
  }

  // 1) your own CRM inputs, wrap on their immediate parent
  document.querySelectorAll('.farlo-ui-crm__input').forEach(input => {
    bindInput(input, inp => inp.parentElement);
  });

  // 2) Gravity Forms inputs, wrap on the .gfield ancestor
  document.querySelectorAll('.gfield input').forEach(input => {
    bindInput(input, inp => inp.closest('.gfield'));
  });

    // 2) Gravity Forms inputs, wrap on the .gfield ancestor
    document.querySelectorAll('.gfield textarea').forEach(input => {
      bindInput(input, inp => inp.closest('.gfield'));
    });
}
